module.exports = __webpack_public_path__ + "img/chinesecompany154.4fddb795.png";